const CREATE = 'CREATE';
const EDIT = 'EDIT';
const DELETE = 'DELETE';

const actionTypes = {
  CREATE,
  EDIT,
  DELETE,
};

export default actionTypes;
